import type { FaireProductEntity } from "../../entity_types/product";

export const p_df9jt0hwsn: FaireProductEntity = {
  token: "p_df9jt0hwsn",
  type: "product",
  name: "RELIEF | Children's (no Willow Bark)",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/1b6de15cd55c8150b0023226348d2c09000c9298d75505080e71f86112b577c8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efdaf3034201f4c9136a5e9699ac320237b79b83bb01a0756023ffd76a234ba3.png",
  ],
  priceDollars: 20.3,
  description:
    "Inflammation is found at the root of most pain, so we developed a formula that combines the most anti-inflammatory agents into one bottle. Now with a cost effective 4 oz refill size!\n\nTO USE: Take 1-2 servings orally as needed for pain or use daily to combat inflammation.\n\nCHILDREN'S INGREDIENTS: ORGANIC LIPOSOMAL CURCUMIN, ORGANIC VEGETABLE GLYCERIN, ORGANIC LIPOSOMAL GINGER, ORGANIC NON-GMO SUNFLOWER LECITHIN, ORGANIC BLACK PEPPER, 100% PURE THERAPEUTIC GRADE ESSENTIAL OIL: COPAIBA.\n\n⚠️ Please Note: Curcumin naturally provides the same effects as blood pressure and diabetes medications. Anyone with these conditions should take extra precaution. We recommend checking with your doctor before making any changes to your dietary routine. Children’s Relief is recommended to use during pregnancy due to willow bark in the adult version.\n\n",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:50:47.647Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
